/* jQuery Equal heights plugin v. 1.0.3 by status201.nl */
!function(i){i.fn.equalHeights=function(n){var o,e={onResize:!0,onLoad:!0},t=i.extend({},e,n),h={},s=0,u=[],a=0,d=0,c=i(this);return c.length<2?this:(t.onResize&&i(window).resize(function(){o&&window.clearTimeout(o),o=window.setTimeout(function(){c.equalHeights({onResize:!1,onLoad:!1})},100)}),t.onLoad&&i(window).load(function(){c.equalHeights({onResize:!1,onLoad:!1})}),c.each(function(){u=i(this),u.height("auto"),a=u.height(),a>0&&(d=u.position().top,s=d in h,s?a>h[d]?(h[d]=a,i(c).filter(function(){return i(this).position().top==d}).height(a)):u.height(h[d]):h[d]=a)}),this)}}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./~/jquery-equalheights/jquery.equalheights.min.js
// module id = 13
// module chunks = 0